import { instance } from '@payments-checkout/shared/helpers/service/instance.service';
import { getRecaptchaToken } from '../usePayment/usePayment.hook';


async function get3dsToken(paymentLinkId: string) {
  const tokenRecaptcha = await getRecaptchaToken();
  const response = await instance.get(`paymentlinks/${paymentLinkId}/threed-secure/token`,
    {
      headers: {
        'g-recaptcha-response': tokenRecaptcha,
      },
    }
  )
  return response.data
}

export { get3dsToken };

